import React from 'react'
import { FormGroup, Label, Input } from 'reactstrap'

function DisableCommentsToggle({ disabled, onChange }) {
    return (
        <FormGroup
            check
            className="d-flex align-items-center gap-2 mt-3 p-3 border rounded bg-light shadow-sm"
        >
            <Input
                style={{marginLeft: '10px'}}
                id="disable-comments"
                type="checkbox"
                checked={disabled}
                onChange={(e) => onChange(e.target.checked)}
            />
            <Label  style={{marginLeft: '48px'}} for="disable-comments" check className="mb-0 fw-semibold">
                Disable comments for all post
            </Label>
        </FormGroup>
    )
}

export default DisableCommentsToggle
